<body class="body-form-signin login-bg">
  <main class="form-register">

    <form class="form-shadow p-4">
      <div class="container justify-content-center">
        <div class="row justify-content-center">
          <div class="text-center">
            <a href="https://cubos.com" target="_blank"> <img class="mb-4" src="assets/images/cubos_cube_rgb.svg" alt="" width="72" height="57"> </a>
            <div class="col-md-12 col mb-2">
              <h4 class="mt-md-1 ml-md-0 ml-4 text-center" i18n="@@E-MailConfirmationHeader">Ihre E-Mail-Adresse wurde erfolgreich bestätigt.</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center round">
        <div class="col-lg-10 col-md-12">
          <div class="form-group">
            <div class="row justify-content-center">
              <div class="col-md-12 col-lg-10 col-12">
                <div class="mb-1 text-center">
                  <br />
                  <button [routerLink]="['/auth/login']" id="tologin" class="w-50 btn btn-yellow" i18n="@@ToLoginButton">Zur Anmeldung</button>
                </div>
                <p class="mt-2 mb-3 text-center text-muted"><a href="https://www.cubos.com" target="_blank" style="text-decoration: none; color: #6c757d;">© {{currentYearLong()}} CUBOS Service GmbH</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </main>
  </body>
